import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=e5776bfe&"
import script from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5776bfe')) {
      api.createRecord('e5776bfe', component.options)
    } else {
      api.reload('e5776bfe', component.options)
    }
    module.hot.accept("./HeaderLogo.vue?vue&type=template&id=e5776bfe&", function () {
      api.rerender('e5776bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderLogo.vue"
export default component.exports